import { render } from "./consume-list.vue?vue&type=template&id=736b4a8e&scoped=true"
import script from "./consume-list.vue?vue&type=script&lang=js"
export * from "./consume-list.vue?vue&type=script&lang=js"

import "./consume-list.vue?vue&type=style&index=0&id=736b4a8e&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736b4a8e"]])

export default __exports__